module.exports = __webpack_public_path__ + "img/1.643b8871.svg";